import { render } from "./UserRegisterApplication.vue?vue&type=template&id=fafa5f30&scoped=true"
import script from "./UserRegisterApplication.vue?vue&type=script&lang=js"
export * from "./UserRegisterApplication.vue?vue&type=script&lang=js"

import "./UserRegisterApplication.vue?vue&type=style&index=0&id=fafa5f30&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fafa5f30"]])

export default __exports__